import { baseKey, searchBaseConfig } from '@otp/utils/baseDataConfig';

export default {
    searchList: {
        searchTxt: [
            {
                name: '客户订单号',
                value: 'customerOrderNo',
                type: 'input',
                unfold: true,
                span: 3
            },
            {
                name: '订单类型',
                value: 'orderType',
                type: 'select',
                optionNum: 'ORDER_TYPE',
                filterable: true,
                unfold: true,
                options: [],
                span: 3
            },
            {
                name: '创建时间',
                value: 'createTime',
                type: 'time',
                unfold: true,
                timeNum: 6,
                span: 6
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        clickModify: true,
        selectBtn: true,
        leftWidth: 100,
        height: 400,
        leftOperation: true,
        columns: [
            {
                label: '订单号',
                value: 'orderNo',
                prop: 'orderNo',
                width: 170,
                sort: true
            },
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                sort: true,
                width: 140
            },
            {
                label: '客户名称',
                prop: 'customerName',
                sort: true,
                width: 140
            },
            {
                label: '订单类型',
                prop: 'orderType',
                type: 'select',
                optionNum: 'ORDER_TYPE',
                width: 110,
                sort: true
            },
            {
                label: '订单状态',
                prop: 'orderStatus',
                type: 'select',
                optionNum: 'TPL_ORDER_STATUS',
                width: 110,
                sort: true
            },
            {
                label: '审核状态',
                prop: 'excuteStatusName',
                type: 'button',
                width: 110,
                sort: true
            },
            {
                label: '平台',
                prop: 'siteName',
                width: 120,
                sort: true
            },
            {
                label: '仓库',
                prop: 'whName',
                value: 'whCode',
                width: 130,
                sort: true
            },
            {
                label: '来源系统',
                prop: 'sourceSystem',
                type: 'select',
                optionNum: 'SOURCE_SYSTEM',
                width: 110,
                sort: true
            },
            {
                label: '推送BMS状态',
                prop: 'putBmsStatus',
                type: 'select',
                optionNum: 'ACCESS_STOCK_PROCESSING_STATUS',
                width: 140,
                sort: true
            },
            {
                label: '推送TMS状态',
                prop: 'putTmsStatus',
                type: 'select',
                optionNum: 'ACCESS_STOCK_PROCESSING_STATUS',
                width: 140,
                sort: true
            },
            {
                label: '订单来源',
                prop: 'orderSourcePlatform',
                type: 'select',
                optionNum: 'ORDER_SOURCE_PLATFORM',
                width: 110,
                sort: true
            },
            {
                label: '收货省份',
                prop: 'receiverProvinceName',
                width: 110,
                sort: true
            },
            {
                label: '收货市',
                prop: 'receiverCityName',
                width: 110,
                sort: true
            },
            {
                label: '收货县',
                prop: 'receiverDistrictName',
                width: 110,
                sort: true
            },
            {
                label: '收货乡镇',
                prop: 'receiverTownName',
                width: 110,
                sort: true
            },
            {
                label: '收货地址',
                prop: 'receiverDetailAddr',
                width: 200,
                sort: true
            },
            {
                label: '收货人',
                prop: 'receiverName',
                width: 100,
                sort: true
            },
            {
                label: '收货人电话',
                prop: 'receiverMobile',
                width: 120,
                sort: true
            },
            {
                label: '收货单位',
                prop: 'receiverUnitName',
                width: 120,
                sort: true
            },
            {
                label: '总毛重',
                prop: 'totalGrossWeight',
                width: 100,
                sort: true
            },
            {
                label: '总体积',
                prop: 'totalVolume',
                width: 100,
                sort: true
            },
            {
                label: '总数量',
                prop: 'totalQty',
                width: 100,
                sort: true
            },
            {
                label: '包件数',
                prop: 'totalPkgQty',
                width: 100,
                sort: true
            },
            {
                label: '上游收货单位',
                prop: 'upperReceiverName',
                width: 130,
                sort: true
            },
            {
                label: '上游发货单位',
                prop: 'upperSenderName',
                width: 130,
                sort: true
            },
            {
                label: '上游源客户',
                prop: 'upperSourceCustomerName',
                width: 140,
                sort: true
            },
            {
                label: '发货省份',
                prop: 'senderProvinceName',
                width: 110,
                sort: true
            },
            {
                label: '发货市',
                prop: 'senderCityName',
                width: 110,
                sort: true
            },
            {
                label: '发货县',
                prop: 'senderDistrictName',
                width: 110,
                sort: true
            },
            {
                label: '发货乡镇',
                prop: 'senderTownName',
                width: 110,
                sort: true
            },
            {
                label: '发货地址',
                prop: 'senderDetailAddr',
                width: 200,
                sort: true
            },
            {
                label: '发货人',
                prop: 'senderName',
                width: 110,
                sort: true
            },
            {
                label: '发货人电话',
                prop: 'senderMobile',
                width: 120,
                sort: true
            },
            {
                label: '发货单位',
                prop: 'senderUnitName',
                width: 120,
                sort: true
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: 160,
                sort: true
            },
            {
                label: '推送BMS异常',
                prop: 'bmsErrMsg',
                width: 160,
                sort: true
            },
            {
                label: '创建人',
                prop: 'createUserCode',
                width: 110,
                sort: true
            },
            {
                label: '修改时间',
                prop: 'updateTime',
                width: 160,
                sort: true
            },
            {
                label: '修改人',
                prop: 'updateUserCode',
                width: 110,
                sort: true
            },
            {
                label: '备注',
                prop: 'remark',
                width: 160,
                sort: true
            },
            {
                label: '供应商编码',
                prop: 'suppliersCode',
                width: 120,
                sort: true
            },
            {
                label: '供应商名称',
                prop: 'suppliersName',
                width: 140,
                sort: true
            },
            {
                label: '承运商编码',
                prop: 'carrierCode',
                width: 120,
                sort: true
            },
            {
                label: '承运商名称',
                prop: 'carrierName',
                width: 140,
                sort: true
            },
            {
                label: '计费组1名称',
                prop: 'materialGroup1Name',
                width: 140,
                sort: true
            },
            {
                label: '计费组1编码',
                prop: 'materialGroup1Code',
                width: 140,
                sort: true
            }
        ],
        action: [
            {
                type: 'text',
                label: '编辑',
                size: 'small',
                event: 'edit',
                ifHas: '02100001'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [
            10,
            20,
            30,
            50
        ]
    },
    // 高级搜索配置项
    searchTotalTitle: [
        { ...searchBaseConfig.customer,
            'advanceConfig': [
                { 'prop': 'pmCodeOrNameCn', 'value': '客户编码或名称' }
            ],
            'advancePlaceholder': "支持模糊查询",
        },
        { ...searchBaseConfig.site,
            'advanceConfig': [
                { 'prop': 'escoCompanyNoOrNameCn', 'value': '服务平台编码或名称' },
            ],
            'advancePlaceholder': "支持模糊查询",
            'tableConfig': [
                { 'prop': 'siteCode', 'value': '服务平台编码' },
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称', 'displayName': true },
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyName', 'value': '分公司名称' }
            ],
            'advanceUrl': '/esCompany/searchSiteV2?escoCompanyType=P',
        },
        { ...searchBaseConfig.wh,
            advanceConfig: [
                { prop: 'codeAndName', value: '仓库编码或名称' }
            // { prop: 'cdwhName', value: '仓库名称' },
            // { prop: 'whCode', value: '仓库编码' }
            ]
        },
        { ...searchBaseConfig.carrierCode },
        {
            name: '来源系统',
            value: 'sourceSystem',
            type: 'select',
            filterable: true,
            optionNum: 'SOURCE_SYSTEM',
            options: []
        },
        {
            name: '订单状态',
            value: 'orderStatus',
            type: 'select',
            optionNum: 'TPL_ORDER_STATUS',
            filterable: true,
            unfold: true,
            options: [],
            span: 4
        },
        {
            name: '审核状态',
            value: 'excuteStatus',
            type: 'select',
            optionNum: 'TPL_EXCUTE_STATUS',
            filterable: true,
            unfold: true,
            options: [],
            span: 4
        },
        {
            name: '推送BMS状态',
            value: 'putBmsStatus',
            type: 'select',
            optionNum: 'ACCESS_STOCK_PROCESSING_STATUS',
            filterable: true,
            unfold: true,
            options: [],
            span: 4
        },
        {
            name: '推送TMS状态',
            value: 'putTmsStatus',
            type: 'select',
            optionNum: 'ACCESS_STOCK_PROCESSING_STATUS',
            filterable: true,
            unfold: true,
            options: [],
            span: 4
        }
    ],
    // 双十一,去掉最近2个月 by曾泓铄
    pickerConfig: {
        shortcuts: [
            { type: 'd', num: 2, text: '最近三天', translate: 'component.E202007300011' },
            { type: 'd', num: 6, text: '最近一周', translate: 'component.E202007300011' },
            { type: 'M', num: 1, text: '最近一个月', translate: 'component.E202007300013' }
        ]
    },
    ImportConfig: {
        action: `${process.env.VUE_APP_API_URL || ''}/api-otp/report/importCostOrderInfo`,
        multiple: false,
        accept: 'xlsx/text',
        showFileList: true,
        fileType: '只能上传Excel文件，且不超过500kb',
        manualUpload: true
    },
    ImportContent: [
        {
            fileName: '纯计费订单-导入模板.xlsx',
            fileSize: '10.80K',
            downLoadInfo: {
                url: '' // 从数据字典ANNTO_FORMWORK_OTP配置
            }
        }
    ],
    viewBillBasicData: {
        customerOrderNoCode: {
            ...baseKey.customer,
            name: '请选择客户名称',
            advanceLabel: '客户名称',
            value: 'customerName',
            match: true,
            popperSize: 'small',
            cbParams: ['pmCode#upperCustomerCode', 'ebcuNameCn#upperCustomerName'],
            'advanceConfig': [
                { 'prop': 'pmCodeOrNameCn', 'value': '客户编码或名称' }
            ],
            'advancePlaceholder': "支持模糊查询",
        },
        serviceTypeCode: {
            ...baseKey.site,
            name: '请选择服务平台',
            advanceLabel: '服务平台',
            value: 'siteName',
            match: true,
            popperSize: 'small',
            'advanceConfig': [
                { 'prop': 'escoCompanyNoOrNameCn', 'value': '服务平台编码或名称' },
            ],
            'advancePlaceholder': "支持模糊查询",
            'tableConfig': [
                { 'prop': 'siteCode', 'value': '服务平台编码' },
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称', 'displayName': true },
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyName', 'value': '分公司名称' }
            ],
            'advanceUrl': '/esCompany/searchSiteV2?escoCompanyType=P',
        },
        customerWhCode: {
            ...baseKey.wh,
            name: '请选择仓库',
            advanceLabel: '仓库',
            advanceConfig: [
                { prop: 'codeAndName', value: '仓库编码或名称' }
                // { prop: 'cdwhName', value: '仓库名称' },
                // { prop: 'whCode', value: '仓库编码' }
            ],
            value: 'upperWhName',
            match: true,
            popperSize: 'small',
            advanceCascade: 'siteCode',
            cbParams: ['whCode#upperWhCode', 'cdwhName#upperWhName']
        },
        carTypeCode: {
            ...baseKey.carTypeCode,
            name: '请选择车型',
            advanceLabel: '车型',
            value: 'equipmentName'
        },
        carrierCode: {
            ...baseKey.carrierCode,
            name: '请选择承运商',
            advanceLabel: '承运商',
            value: 'carrierName'
        }
    },
    logJumpParams: {
        customerOrderNo: '',
        ownerCode: '',
        ownerName: '',
        siteCode: '',
        siteName: '',
        whCode: '',
        whName: '',
        companyCode: '',
        companyName: '',
        invType: 'custInv'
    },
    logColumns: [
        {
            prop: 'orderNo',
            label: '订单号',
            type: 'normal'
        },
        {
            prop: 'taskNo',
            label: '任务号',
            type: 'normal'
        },
        {
            prop: 'operateName',
            label: '操作类型',
            type: 'normal'
        },
        {
            prop: 'operateContent',
            label: '操作内容',
            type: 'normal'
        },
        {
            prop: 'createUserCode',
            label: '创建人',
            type: 'normal'
        },
        {
            prop: 'createTime',
            label: '创建时间',
            type: 'normal'
        }
    ]
};
